export const state = () => ({
  banners: [],
  features: [],
  categories: [],
  collections: [],
  whatsappContacts: [],
  client: {},
  selectedProd: {},
  showModal: false,
  showCart: false,
  dollarPrice: true,
  exchange: {},
  orders: []
  // products: []
})

export const mutations = {
  // SET_Products (state, data) {
  //   state.products = data
  // },
  SET_Categories (state, data) {
    state.categories = data
    // state.categories.sort((a, b) => a.name > b.name ? -1 : 1)
  },
  SET_Collections (state, data) {
    state.collections = data
  },
  SET_Features (state, data) {
    state.features = data
  },
  SET_Exchange (state, data) {
    state.exchange = data
  },
  SET_Banners (state, data) {
    state.banners = data
  },
  SET_WhatsappContacts (state, data) {
    state.whatsappContacts = data
  },
  SET_DollarPrice (state) {
    state.dollarPrice = !state.dollarPrice
  },
  SET_Orders (state, data) {
    state.orders = data
  },
  INIT_SET_Store (state) {
    if (localStorage.getItem('cartItemList')) {
      state.cart.cartItemList = JSON.parse(localStorage.getItem('cartItemList'))
    }
  },
  ADD_Item (state, prod) {
    prod.qty = 1
    state.storeCart.push(prod)
    // const mobCartBody = document.querySelector('.mobCartBody')
    // mobCartBody.scrollLeft = mobCartBody.scrollWidth
  },
  SEL_ProdModal (state, prod) {
    state.selectedProd = prod
  },
  SHOW_Cart (state, force) {
    state.showCart = force ? true : !state.showCart
  },
  HIDE_Cart (state) {
    state.showCart = false
  },
  SHOW_Modal (state, act) {
    state.showModal = act != null ? act : !state.showModal
  },
  SET_AUTH (state, { user, loggedIn }) {
    state.auth.user = user
    state.auth.loggedIn = loggedIn
  }
}

export const actions = {
  async nuxtServerInit ({ commit, dispatch }, { req }) {
    let user = null
    let loggedIn = false
    // if (req.headers.cookie) {
    if (this.$auth.$storage.getCookie('user')) {
      try {
        user = this.$auth.$storage.getCookie('user')
        loggedIn = true
      } catch (err) {
        user = null
      }
    }
    // console.log(auth)
    await commit('SET_AUTH', { user, loggedIn }) // set state auth
    try {
      await dispatch('GET_WebsiteData')
    } catch (e) {
      // eslint-disable-next-line
      console.error('GET_WebsiteData failed', e)
    }
  },
  async GET_Products ({ commit }) {
    const { data } = await this.$axios.get(`/products?vendor_id=${this.$config.STORE_ID}&simpleList=true`)
    const safeData = JSON.parse(JSON.stringify(data))
    commit('SET_Products', safeData)
  },
  async GET_WebsiteData ({ commit }) {
    const selectedCompany = (this.app && this.app.$config && this.app.$config.STORE_SHORT_NAME) || ''
    const { data } = await this.$axios.get('/website', {
      params: {
        _t: Date.now(),
        selectedCompany
      },
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    })
    const safeData = JSON.parse(JSON.stringify(data))
    commit('SET_Categories', safeData.categories)
    commit('SET_Collections', safeData.collections)
    commit('SET_Features', safeData.features)
    commit('SET_Exchange', safeData.exchange)
    commit('SET_Banners', safeData.banners)
    let whatsappContacts = []
    const w = safeData.whatsapp_contacts
    if (typeof w === 'string') {
      try {
        whatsappContacts = JSON.parse(w)
      } catch (e) {
        whatsappContacts = []
      }
    } else if (Array.isArray(w)) {
      whatsappContacts = w
    }
    commit('SET_WhatsappContacts', Array.isArray(whatsappContacts) ? whatsappContacts : [])
  },
  async GET_Orders ({ commit }) {
    // const { data } = await this.$axios.get('services/wholesale/service_orders.php?i=grid&e=' + this.$auth.getToken('local'))
    const { data } = await this.$axios.get('/orders')
    const safeData = JSON.parse(JSON.stringify(data))
    commit('SET_Orders', safeData)
  }
}

export const getters = {
  categories: () => {
    return state.categories
  },
  collections: () => {
    return state.collections
  },
  getRealPrice: (state) => {
    const moneyFormat = Intl.NumberFormat(state.dollarPrice ? 'en-US' : 'es-VE', { style: 'currency', currency: state.dollarPrice ? 'USD' : 'VES', currencyDisplay: 'symbol' })
    return (price) => {
      return moneyFormat.format(state.dollarPrice ? price : (price * state.exchange.rate))
    }
  },
  getGroupedAttributes: (state) => {
    return (product) => {
      let grouped = {}
      if (product.attributes) {
        grouped = product.attributes.reduce(function (r, a) {
          r[a.feature_id] = r[a.feature_id] || []
          r[a.feature_id].push(a)
          return r
        }, Object.create({}))
      }
      return grouped || []
    }
  },
  getFeatureById: (state) => {
    return (feature) => {
      return state.features.find(elm => elm.id === Number(feature))
    }
  },
  findCatById: (state) => {
    return (category) => {
      return state.categories.find(elm => elm.id === Number(category))
    }
  },
  findCatByName: (state) => {
    return (category) => {
      return state.categories.find(elm => category === elm.name.toLowerCase().replace(/ /g, '-'))
    }
  },
  findCatByProdId: (state) => {
    return (id) => {
      const prod = state.products.find(elm => elm.id === id)
      return prod.id_categoria.toLowerCase().replace(/ /g, '-')
    }
  },
  findOrderById: (state) => {
    return (id) => {
      return state.orders.find(elm => elm.id === id)
    }
  },
  whatsappContacts: (state) => {
    return state.whatsappContacts
  },
  getFormData: (state) => {
    return (object) => {
      const formData = new FormData()
      Object.entries(object).forEach(([key, value]) => { formData.append(key, value) })
      return formData
    }
  }
}
